export class LoadBillings {
  static readonly type = '[Billings] Load Billings'

  constructor() { }
}